<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochd"><a id="page_3"></a>Contents</h1>
<h2 class="toc1"><a href="#/xhtml/04_Introduction"><span class="bold">Introduction</span></a></h2>
<h2 class="toc1"><span href="#/xhtml/05_Deployment" title="Link target outside of Sample"><span class="bold">Deployment on the Eastern and Western Fronts up to Summer 1944</span></span></h2>
<h2 class="toc1"><span href="#/xhtml/06_Assessment" title="Link target outside of Sample"><span class="bold">Assessment of the German Situation in Holland, September 1944</span></span></h2>
<h2 class="toc2"><span href="#/xhtml/07_Chapter1" title="Link target outside of Sample">Chapter One</span></h2>
<h2 class="toc3"><span href="#/xhtml/07_Chapter1" title="Link target outside of Sample"><span class="bold">The Landings</span></span></h2>
<h2 class="toc2"><span href="#/xhtml/08_Chapter2" title="Link target outside of Sample">Chapter Two</span></h2>
<h2 class="toc3"><span href="#/xhtml/08_Chapter2" title="Link target outside of Sample"><span class="bold">First Attacks</span></span></h2>
<h2 class="toc2"><span href="#/xhtml/09_Chapter3" title="Link target outside of Sample">Chapter Three</span></h2>
<h2 class="toc3"><span href="#/xhtml/09_Chapter3" title="Link target outside of Sample"><span class="bold">Battle for Arnhem</span></span></h2>
<h2 class="toc2"><span href="#/xhtml/10_Chapter4" title="Link target outside of Sample">Chapter Four</span></h2>
<h2 class="toc3"><span href="#/xhtml/10_Chapter4" title="Link target outside of Sample"><span class="bold">Retaking Arnhem</span></span></h2>
<h2 class="toc1"><span href="#/xhtml/11_Epilogue" title="Link target outside of Sample"><span class="bold">Epilogue</span></span></h2>
<h2 class="toc2"><span href="#/xhtml/12_Appendix1" title="Link target outside of Sample">Appendix I</span></h2>
<h2 class="toc3"><span href="#/xhtml/12_Appendix1" title="Link target outside of Sample"><span class="bold">Order of Battle, Holland, September 1944</span></span></h2>
<h2 class="toc2"><span href="#/xhtml/13_Appendix2" title="Link target outside of Sample">Appendix II</span></h2>
<h2 class="toc3"><span href="#/xhtml/13_Appendix2" title="Link target outside of Sample"><span class="bold">Composition of a Waffen-SS and Wehrmacht Infantry and Panzergrenadier Division 1944</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?711d712f